import type { CountyAdapter, ParsedDocument } from "../types";

const parseDate = (s: string): string | null => {
  if (!s) return null;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [m, d, y] = s.split("/");
    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  return null;
};

const PROPERTY_KEYWORDS = [
  "TOWNSHIP", "Section:", "LOT", "PARCEL", "ZANESVILLE", "ROSEVILLE", "PHILO",
  "DRESDEN", "FRAZEYSBURG", "ADD", "SUB", "ACRES", "A SEE", "PUTNAM",
  "BRIGHTON", "FULTONHAM", "NEWTON", "FALLS", "CITY", "QT", "PT",
];

const parse = (text: string): ParsedDocument[] => {
  const lines = text.split("\n");
  const out: ParsedDocument[] = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (!(line.includes("OFF") && line.includes("LAND CONTRACT"))) {
      i++;
      continue;
    }
    const parts = line.split("\t").filter((p) => p.trim());
    let dateStr = "";
    for (let j = 0; j < parts.length; j++) {
      if (parts[j] === "OFF" && j + 1 < parts.length) {
        dateStr = parts[j + 1];
        break;
      }
    }
    const collected: string[] = [];
    let documentNumber = "";
    let j = i + 1;
    while (j < lines.length) {
      const next = lines[j].trim();
      if (/^\d{4}\s*\/\s*\d{1,4}$/.test(next)) {
        documentNumber = next.replace(/\s/g, "");
        break;
      }
      if (next.includes("OFF") && next.includes("LAND CONTRACT")) break;
      if (
        next === "L/C" ||
        next === "CONTRACT FOR DEED" ||
        next.includes("pages") ||
        next.includes("Flag") ||
        next === "" ||
        next.startsWith("-----")
      ) {
        j++;
        continue;
      }
      collected.push(next);
      j++;
    }

    if (documentNumber && collected.length > 0) {
      let split = 0;
      for (let k = 0; k < collected.length; k++) {
        if (
          PROPERTY_KEYWORDS.some((kw) =>
            collected[k].toUpperCase().includes(kw),
          )
        ) {
          split = k;
          break;
        }
      }
      const nameLines = collected.slice(
        0,
        split || Math.ceil(collected.length / 2),
      );
      const propLines = collected.slice(
        split || Math.ceil(collected.length / 2),
      );
      const grantor = nameLines[0] || "";
      const grantee = nameLines.slice(1).join(" ");
      out.push({
        documentNumber,
        documentType: "LAND CONTRACT",
        filingDate: parseDate(dateStr) || new Date().toISOString().split("T")[0],
        grantors: grantor ? [grantor] : [],
        grantees: grantee ? [grantee] : [],
        propertyAddress: propLines.join(" ") || undefined,
      });
    }
    i = j;
  }
  return out;
};

export const muskingumAdapter: CountyAdapter = {
  countyId: "muskingum",
  countyLabel: "Muskingum County, OH - Land Contract Parser",
  description:
    "Paste Muskingum County data with tab-separated OFF/date lines and document numbers in #### / #### format.",
  placeholder: "Paste the full Muskingum County data here...",
  detectionReasons: ["Muskingum County OH", "Land Contract"],
  confidenceScore: 80,
  parse,
};
